import { render } from "./GenerateResourcesDialog.vue?vue&type=template&id=7bcd14c6&scoped=true"
import script from "./GenerateResourcesDialog.vue?vue&type=script&lang=js"
export * from "./GenerateResourcesDialog.vue?vue&type=script&lang=js"

import "./GenerateResourcesDialog.vue?vue&type=style&index=0&id=7bcd14c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcd14c6"]])

export default __exports__